import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { authSlice } from "./auth";
import { API } from "./api";
import "./settlementApi";
import "./adminPlatformSettingsApi";
import "./smsMessagingAdminApi";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    [API.reducerPath]: API.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(API.middleware),
});

setupListeners(store.dispatch);
